import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Box } from "@material-ui/core";
import * as PropTypes from "prop-types";
//Usar este en vez de Container con maxwidth porque le mete muchos margenes

const BoxCustom = withStyles((theme) => ({
    root: {
        width: "100%",
        display: "flex",
        flexWrap:"nowrap",
    },
}))(Box);

export default function ContainerDoble(props) {
    return (
        <BoxCustom component={"div"} className={props.className} style={props.style}>
            {props.children}
        </BoxCustom>
    )
}

ContainerDoble.propTypes = {
    style: PropTypes.object,
    className: PropTypes.any,
};
